import {
  AfterContentChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { last } from 'lodash';
@Component({
  selector: 'app-upload-dnd',
  templateUrl: './upload-dnd.component.html',
  styleUrls: ['./upload-dnd.component.scss'],
})
export class UploadDndComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  files: any[] = [];
  fileUploadDoc: any = {};
  attachments: any[] = [];
  //baseUrl = environment.BASE_URL;
  baseUrl: string = '';
  @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef | undefined;
  @ViewChild('fileSelector') fileSelector: ElementRef<HTMLElement> | undefined;

  @Input() documentInfo: any;
  @Input() fileUploadConfig: any;
  @Input() resetFileUpload: boolean = false;
  @Input() showDragDrop: boolean = true;
  @Output() fileUploadEvent = new EventEmitter<any>();
  fileFormats: string = '';

  fileUploadForm!: FormGroup;
  loader: boolean = false;
  uploadedFiles: any[] = [];
  constructor(
    private toastr: ToastrService,
    private http: HttpClient,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    let resetChange = changes['resetFileUpload'];
    if (resetChange && resetChange.currentValue) {
      this.files = [];
      this.resetFileUpload = false;
    }
  }

  resetSelectedFileState() {
    this.files = [];
  }

  ngAfterContentChecked(): void {
    this.baseUrl = this.documentInfo.baseUrl;
    this.fileFormats = this.fileUploadConfig.fileFormats;
  }

  onFileDropped($event: any): void {
    this.prepareFilesList($event);
  }
  fileBrowseHandler(event: any): void {
    // this.prepareFilesList(files?.target?.files);
    let tempFiles: File[] = event?.target?.files;

    const fileExt = last(tempFiles[0].name.split('.'));

    if (tempFiles[0].size > this.fileUploadConfig.fileSizeLimit) {
      this.toastr.error('File size exceeds');
      return;
    }

    if (!this.fileUploadConfig.fileFormats.includes(fileExt)) {
      this.toastr.error('Invalid file extension');
      return;
    } else {
      this.prepareFilesList(event?.target?.files);
    }
  }
  prepareFilesList(tempFiles: Array<any>) {
    if (this.files.length + tempFiles.length > 5) {
      this.toastr.error('File limit of 5 exceeded.');
      return;
    }

    if(!this.fileUploadConfig?.isMultiple && tempFiles.length>1)
     {
      this.toastr.error('Cannot upload more than one file.');
      return;
     }
    
    for (const item of tempFiles) {
      if (item?.progress) {
        item.progress = 0;
      }
      if (item?.name) {
        const fileNameList = item?.name?.split('.');
        item['fileType'] = last(fileNameList);
      }
      this.files.push(item);
    }
    if (this?.fileDropEl) {
      this.fileDropEl.nativeElement.value = '';
    }
    this.getFileUploadS3UrlAndUpload();
  }
  getFileUploadS3UrlAndUpload(): void {
    this.uploadedFiles = []; //reset

    if (!this.files.length) {
      return;
    }

    const uploadPromises = this.createPromisArrayOfFiles();

    Promise.all(uploadPromises)
      .then(() => {
        this.fileUploadDoc = {
          fileUploadStatus: true,
          attachment: this.uploadedFiles,
        };
        this.fileUploadEvent.emit(this.fileUploadDoc);
      })
      .catch((error) => {
        this.toastr.error('Something went wrong!');
        this.files = [];
        this.fileUploadDoc = {
          fileUploadStatus: false,
          attachment: [],
        };
        this.fileUploadEvent.emit(this.fileUploadDoc);
        console.log(error);
      })
      .finally(() => {
        this.loader = false;
      });

  }

  formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  async awsBasicUploadSingle(url: string, file: File) {
    const HttpUploadOptions = {
      headers: new HttpHeaders({ 'Content-Type': file.type }),
    };

    return new Promise<void>((res, rej) => {
      this.http.put(url, file, HttpUploadOptions).subscribe({
        next: (data: any) => {
          //this.toastr.success(`File uploaded successfully ${file.name}`);
          // const fileUploadDoc: any = {};

          // fileUploadDoc.fileUploadStatus = true;
          // fileUploadDoc.attachment = attachment;
          // this.loader = false;
          res();
        },
        error: (error: HttpErrorResponse) => {
          // this.loader = false;
          // this.fileUploadDoc.fileUploadStatus = false;
          // this.toastr.error(error.error.status.error.message);
          rej(error);
        },
      });
    });
  }

  chooseFiles(): void {
    if (this?.fileSelector) {
      let el: HTMLElement = this?.fileSelector?.nativeElement;
      el.click();
    }
  }

  deleteFile(index: number) {
    if (this.files[index]?.progress < 100) {
      return;
    }

    if (!this.isOrderSame(this.files, this.fileUploadDoc.attachment)) {
      this.fileUploadDoc.attachment = this.reorderArray(
        this.files,
        this.fileUploadDoc.attachment,
      );
    }

    this.files.splice(index, 1);
    this.fileUploadDoc.attachment.splice(index, 1);

    this.fileUploadEvent.emit(this.fileUploadDoc);
  }

  private createPromisArrayOfFiles() {
    return this.files.map((file) => {
      return new Promise<void>((res, rej) => {
        const fileNameList = file?.name?.split('.');
        const filesData = {
          fileName: file.name,
          type: file.fileType || file.type,
          size: this.formatBytes(file.size),
          userType: this.documentInfo.userType,
          location: `${this.fileUploadConfig.fileLocation}/${fileNameList[0]}.${fileNameList[1]}`,
          documentUseFor: this.documentInfo.documentUseFor,
        };

        this.http
          .post(`${this.baseUrl}auth-service/file-management`, filesData)
          .subscribe({
            next: async (data: any) => {
              const fileData = data.response;
              const attachment = {
                id: fileData.id,
                type: fileData.type,
                rfqTemplateType: fileData.documentUseFor,
                fileName: fileData.fileName,
                location: fileData.location,
                updatedOn: fileData.updatedOn,
                fileType: fileData.documentUseFor,
                size: fileData.size,
              };

              try {
                await this.awsBasicUploadSingle(data.response.presignedUrl, file);

                this.uploadedFiles.push(attachment);
                res();
              } catch (error: any) {
                // this.toastr.error('Something went wrong.');
                console.log(error);
                rej(error);
              }
              // this.updateRFQFile();
            },
            error: (error: HttpErrorResponse) => {
              // this.toastr.error(error.error.status.error.message);
              console.log(error);
              rej(error);
            },
          });
      });
    });
  }

  private isOrderSame(selectedFiles: any[], uploadedFiles: any[]) {
    if (selectedFiles.length !== uploadedFiles.length) return false;

    for (let i = 0; i < selectedFiles.length; i++) {
      if (selectedFiles[i].name !== uploadedFiles[i].fileName) {
        return false;
      }
    }

    return true;
  }

  private reorderArray(selectedFiles: any[], uploadedFiles: any[]) {
    const map = new Map();

    uploadedFiles.forEach((item, index) => {
      map.set(item.fileName, index);
    });

    return selectedFiles.map((item) => uploadedFiles[map.get(item.name)]);
  }
}
